import { District, Ward } from "../models/index";

export class DataHubRouteViewModel {
    selectedProvinceCiyIds:number[];
    selectedDistrictIds:number[];
    districts: District[];
    wards: Ward[];
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/view-model/dataHubRoute.viewModel.ts